import Joi from "joi-browser";

class SourceModel {
    constructor(id = 0, sourceKindId = 0, name= "", weight = 0, active = true) {
        this.id = id;
        this.sourceKindId = sourceKindId;
        this.name = name;
        this.weight = weight;
        this.active= active;
    }
}

export const SourceSchema = {
    name: Joi.string().max(250).required(),
    weight: Joi.number().min(0).max(2147483647).required()
}

export {SourceModel}